<template>
    <div class="customer_home siteWithdraw_container">
        <div class="main_table">
            <div class="Trans__btn_container">
                <!-- <div class="search_query">
                  <input type="text"  class="input_text" placeholder="Search query" v-model="searchQuery">
                </div>
                <md-button class="md-raised md-primary Tran_btn btn_search" @click="doSearch"> 
                    <svg  style="margin-right:8px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8184 21.9373L17.4468 16.5678C18.8966 14.9157 19.7777 12.7519 19.7777 10.3857C19.7777 5.21029 15.5653 1 10.3888 1C5.21133 0.998962 1 5.21029 1 10.3847C1 15.5591 5.21237 19.7704 10.3888 19.7704C12.7519 19.7704 14.9136 18.8924 16.5657 17.4468L21.9383 22.8174C22.0598 22.9398 22.2196 23 22.3784 23C22.5382 23 22.697 22.9388 22.8184 22.8174C23.0623 22.5745 23.0623 22.1802 22.8184 21.9373ZM10.3889 18.5251C5.89836 18.5251 2.24536 14.8731 2.24536 10.3847C2.24536 5.89626 5.89836 2.24429 10.3889 2.24429C14.8794 2.24429 18.5324 5.89626 18.5324 10.3847C18.5324 14.8731 14.8794 18.5251 10.3889 18.5251Z" fill="white"/>
                    </svg>
                    <strong>Search</strong>
                </md-button> -->
                <export-excel
                   type    = "csv"
                    name    = "Device Return Overdue.csv"
                    :fields="dataFieldsExport"
                    :before-generate="handleExport"
                    :data   = "totalLogSearch" 
                >
                    <md-button class="md-raised Tran_btn btn_export" >       
                        <svg style="margin-right:8px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0)">
                            <path d="M23.75 4.87515L18.75 1.12514C18.5625 0.982639 18.3075 0.960139 18.0963 1.06639C17.8838 1.17264 17.75 1.38889 17.75 1.62514V3.50015H15.875C12.0838 3.50015 9 6.58391 9 10.3752C9 10.6652 9.2 10.9177 9.48125 10.9839C9.52875 10.9952 9.5775 11.0002 9.625 11.0002C9.8575 11.0002 10.0763 10.8702 10.1838 10.6552L10.3313 10.3614C11.29 8.44266 13.2175 7.25016 15.3625 7.25016H17.75V9.12516C17.75 9.36141 17.8838 9.57766 18.095 9.68391C18.3063 9.79016 18.5613 9.76766 18.75 9.62516L23.75 5.87515C23.9075 5.75765 24 5.5714 24 5.37515C24 5.1789 23.9075 4.99265 23.75 4.87515Z" fill="#0080F7"/>
                            <path d="M10.25 2L3.75 2C2.233 2 0.999998 3.233 0.999998 4.75L1 20.25C1 21.767 2.233 23 3.75 23L15.25 23C16.767 23 18 21.767 18 20.25L18 11.75C18 11.336 17.664 11 17.25 11C16.836 11 16.5 11.336 16.5 11.75L16.5 20.25C16.5 20.939 15.939 21.5 15.25 21.5L3.75 21.5C3.061 21.5 2.5 20.939 2.5 20.25L2.5 4.75C2.5 4.061 3.061 3.5 3.75 3.5L10.25 3.5C10.664 3.5 11 3.164 11 2.75C11 2.336 10.664 2 10.25 2Z" fill="#0080F7"/>
                            <path d="M13.25 19.5H5.75C5.336 19.5 5 19.164 5 18.75C5 18.336 5.336 18 5.75 18H13.25C13.664 18 14 18.336 14 18.75C14 19.164 13.664 19.5 13.25 19.5Z" fill="#0080F7"/>
                            <path d="M12.25 15.5H5.75C5.336 15.5 5 15.164 5 14.75C5 14.336 5.336 14 5.75 14H12.25C12.664 14 13 14.336 13 14.75C13 15.164 12.664 15.5 12.25 15.5Z" fill="#0080F7"/>
                            </g>
                            <defs>
                            <clipPath id="clip0">
                            <rect width="24" height="24" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                        <strong>Export file</strong>
                    </md-button>
                 </export-excel> 
                <!-- <DatePicker class=" btn_time" @confirm="confirmFilterDate" /> -->
            </div>
            <md-table v-model="overdue" md-card style="max-height:750px">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                
                <!-- <md-table-cell md-label="Shelf" >{{ item.shelfName ? item.shelfName : '' }}</md-table-cell> -->
                <!-- <md-table-cell md-label="Bin" >{{item.shelfName+'-'+item.binName.split(' ')[1] }}</md-table-cell> -->
                <!-- <md-table-cell md-label="Item" >{{ item.itemName }}</md-table-cell> -->
                <!-- <md-table-cell md-label="Model" >{{ item.partNo }}</md-table-cell> -->
                <!-- <md-table-cell md-label="Serial Number"  >{{ item.serialNumber }}</md-table-cell> -->
                
                <md-table-cell  md-label="Employee Number">{{ item.user ? item.user.emNum : '' }}</md-table-cell>
                <md-table-cell  md-label="Full Name" >{{ item.user ? item.user.name : '' }}</md-table-cell>
                <md-table-cell  md-label="Company">{{ item.user ? item.user.dept : '' }}</md-table-cell>
                <md-table-cell  md-label="Position">{{ item.user ? item.user.position : '' }}</md-table-cell>
                <md-table-cell  md-label="Role">{{ item.role ? item.role : '' }}</md-table-cell>
                <md-table-cell md-label="Model" >{{ item.partNo }}</md-table-cell>
                <md-table-cell md-label="Tag Number"  >{{ item.tag }}</md-table-cell>
                <md-table-cell md-label="Location"  >{{ item.roomName ? item.roomName : ''}}</md-table-cell>
                <!-- <md-table-cell  md-label="Picked Quantity">{{ item.quantityChanged }}</md-table-cell>
                <md-table-cell  md-label="Type of Service">{{ item.serviceType?'Return':'Picked' }}</md-table-cell>
                <md-table-cell  md-label="Bin Status">{{ item.binStatus?item.binStatus:'' }}</md-table-cell> -->
                <md-table-cell md-label="Last Borrow Time" >{{item.lastBorrow}}</md-table-cell>
                <md-table-cell md-label="Last Return Time" >{{item.lastReturn}}</md-table-cell>
                <md-table-cell md-label="Loan duration" >{{item.duration}}</md-table-cell>
                </md-table-row>
            </md-table>
        </div>

        <Pagination  class="table_pagination" v-if='pagiShow'
          v-model="currentPage" 
          :page-count="totalPages"
          @change="onChange"
        />
</div>
</template>
<script>
import request from '@/utils/request'
// import DatePicker from '../../components/DatePicker'
import Pagination from '../../components/Pagination'
const getRole=(role)=>{
    switch(role){
        case 'STAFF':
          return 'Staff'
        case 'OPERATOR':
          return 'Admin'
        case 'MASTER':
          return 'Super Admin'
        case 'CONTRACTOR':
          return 'Contractor'
        case 'CUSTOMER':
          return 'Customer site'
    }
}
const getDuration=(totalSecond)=>{
//   let totalSecond = (now-temp)/(1000*60)
  if(totalSecond==0){
      return 'NA'
  }
  let diffHour = Math.floor(totalSecond/(60*60))
  let diffMin = Math.floor((totalSecond-diffHour*60*60)/60)
  let diffSecond=Math.floor(totalSecond-diffHour*3600-diffMin*60)
  let res = `${diffHour.toString().padStart(2,'0')} hrs ${diffMin.toString().padStart(2,'0')} mins ${diffSecond.toString().padStart(2,'0')} s`
  return res
}
export default {
  name:'SiteWithdraw',
  components:{
    //   DatePicker,
      Pagination
  },
  created() {
    this.timeQuery= this.$store.state.overTime
    console.log("over time query:",this.timeQuery)
    request('get', `/overdue/page/${this.currentPage}?site=${this.siteId}&time=${this.timeQuery}`)
    .then(data => {
        
        this.overdue = data.overdue.map(el=>{
            let role = el.user?getRole(el.user.role):''
            return  {
                ...el,
                role:role,
                duration:getDuration(el.timeUse),
                lastBorrow:this.convertTime(el.borrowTime),
                lastReturn:el.returnTime?this.convertTime(el.returnTime):'NA'

            }
        })
        this.totalPages=data.pages
    })
    .catch(err => console.log(err))
  },
  data(){
    return{
      currentPage: 1,
      totalPages:0,
      siteId: this.$route.params.id,
      overdue: [],
      timeQuery:0,
    //   startDate: '',
    //   endDate: '',
    //   searchQuery: '',
      totalLogSearch:[],
      dataFieldsExport:{
        
        
        "Employee Number":"user.emNum",
        "Full Name":"user.name",
        "Company":"user.dept",
        "Position":"user.position",
        "Role":"role",
        "Model":"partNo",
        "Tag Number":"tag",
        "Location":"roomName",
        "Last Borrow Time":"lastBorrow",
        "Last Return Time":"lastReturn",
        "Loan Duration":"duration"

      }
    }
    
  },
  methods: {
    onChange: function () {
        request('get', `/overdue/page/${this.currentPage}?site=${this.siteId}&time=${this.timeQuery}`)
        .then(data => {
            this.overdue = data.overdue.map(el=>{
                let role = el.user?getRole(el.user.role):''
                return  {
                    ...el,
                    role:role,
                    duration:getDuration(el.timeUse),
                    lastBorrow:this.convertTime(el.borrowTime),
                    lastReturn:el.returnTime?this.convertTime(el.returnTime):'NA'

                }
            })
            this.totalPages=data.pages
        })
        .catch(err => console.log(err))
    },
    handleExport: async function()
    {
        this.totalLogSearch=[]
        try{
            let data = await request('get',  `/overdue/export?site=${this.siteId}&time=${this.timeQuery}`)
            
            this.totalLogSearch = data.overdue.map(el=>{
                let role = el.user?getRole(el.user.role):''
                return  {
                    ...el,
                    role:role,
                    duration:getDuration(el.timeUse),
                    lastBorrow:this.convertTime(el.borrowTime),
                    lastReturn:el.returnTime?this.convertTime(el.returnTime):'NA'

                }
            });
        }
        catch(err)
        {
            console.log(err)
            alert("Failed to export data!")
        }
    },
    convertTime(time)
    {
        let dt = new Date(time)
        return `${
            (dt.getFullYear()).toString().padStart(4, '0')}-${
            (dt.getMonth()+1).toString().padStart(2, '0')}-${
            dt.getDate().toString().padStart(2, '0')} ${
            dt.getHours().toString().padStart(2, '0')}:${
            dt.getMinutes().toString().padStart(2, '0')}:${
            dt.getSeconds().toString().padStart(2, '0')}`
    }
  },
  computed: {
    pagiShow() {
      if(this.totalPages>0) {
          return true;
      }
      return false;
    }
  }
}
</script>
<style lang="scss" >
 .siteWithdraw_container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    .main_table{
        align-items:flex-end;
        position: relative;
        z-index: 1;
        .Trans__btn_container{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            position: relative;
            width: 100%;

            .search_query {
                input {
                    font-size: 1rem;
                    height: 48px;
                    position: relative;
                    padding-left: 8px;
                    padding-right: 8px;
                    top: 6px;
                    background-color:white;
                    border-width: 0px;
                    border-radius: 2px;
                    outline: none
                }
                 .input_select:hover,:focus{
                    border:1px solid #0080F6 !important ;
                }
            }

            .Tran_btn{
                // background-color: #0080F7;
                font-size: 1rem;
                margin-bottom: 26px;
                margin-right: 0px;
                 .md-button-content{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            .btn_search{
                margin-right: 24px;
                width: 147px;
            }
            .btn_export{
                width: 171px;
                background: white;
                border: 2px solid #0080F7;
                color: #0080F7 !important;
               
               
            }
            .btn_time{
                
                position: absolute;
                left: 0px;
                top:5px;
                
            }
        }
    }
    
 }

</style>